var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnvelopeOpen = function SvgIconEnvelopeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.445 2.168a1 1 0 0 1 1.11 0l9 6A1 1 0 0 1 22 9v9.75a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75V9a1 1 0 0 1 .445-.832zM4 10.942l4.632 3.304L4 17.52zM6.077 18.5h11.846l-4.6-3.25h-2.646zm4.603-5.25h2.64l5.919-4.222L12 4.202 4.761 9.028zM20 10.942l-4.632 3.304L20 17.52z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEnvelopeOpen;